import { DatamodelViewService } from '@/general/services/overview-service/modules/datamodel-view.service';
import { InjectionKey, Ref } from 'vue';

export const datamodelServiceKey = Symbol() as InjectionKey<Ref<DatamodelViewService>>;
